import BaseIcon from './BaseIcon';


export default (Vue) => {
  Vue.component(BaseIcon.name, BaseIcon);
};



// WEBPACK FOOTER //
// ./src/components/common/base-icon/index.js